import { Injectable } from "@angular/core";
import { BehaviorSubject, map, Observable } from "rxjs";

export type LoadingState = Record<string, boolean>;

@Injectable({
  providedIn: "root",
})
export class LoaderService {
  state: BehaviorSubject<LoadingState> = new BehaviorSubject<LoadingState>({});

  constructor() {
    // this.state.subscribe((state: LoadingState) => {
    //   console.log(state);
    // });
  }

  setLoading(page: string, state: boolean) {
    this.state.next({ ...this.state.value, [page]: state });
  }

  getState(): Observable<boolean> {
    return this.state
      .asObservable()
      .pipe(map((st) => Object.values(st).some((value) => value === true)));
  }

  getProgress(): Observable<number> {
    return this.state.asObservable().pipe(
      map((st) => {
        const totalItems = Object.keys(st).length;
        if (totalItems === 0) return 0; // Avoid division by zero

        const completedItems = Object.values(st).filter(
          (value) => !value,
        ).length;

        // Calculate the percentage of completed items (0 to 100)
        return (completedItems / totalItems) * 100;
      }),
    );
  }

  isLoading(endpoint: string): Observable<boolean> {
    return this.state
      .asObservable()
      .pipe(
        map((st) =>
          Object.entries(st).some(
            ([key, value]) => key.includes(endpoint) && value,
          ),
        ),
      );
  }
}
